import FileSaver from "file-saver";

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

/**
 * Truncates filename in the middle to preserve extension.
 * Example: "very-long-filename-here.pdf" → "very-long-f...ere.pdf"
 */
export const truncateFilename = (
  filename: string,
  maxLength: number,
): string => {
  if (filename.length <= maxLength) return filename;

  const lastDotIndex = filename.lastIndexOf(".");
  const hasExtension = lastDotIndex > 0;

  if (!hasExtension) {
    // No extension, just truncate at end
    return filename.slice(0, maxLength - 3) + "...";
  }

  const extension = filename.slice(lastDotIndex);
  const nameWithoutExt = filename.slice(0, lastDotIndex);

  // Reserve space for extension + ellipsis
  const availableLength = maxLength - extension.length - 3;
  if (availableLength <= 0) {
    // Extension too long, just show truncated extension
    return "..." + extension;
  }

  // Split available space between start and end of name
  const startLength = Math.ceil(availableLength / 2);
  const endLength = Math.floor(availableLength / 2);

  return (
    nameWithoutExt.slice(0, startLength) +
    "..." +
    nameWithoutExt.slice(-endLength) +
    extension
  );
};

export const downloadText = (text: string, filename: string): void => {
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });

  FileSaver.saveAs(blob, filename);
};

export const downloadJSON = (data: any, filename: string): void => {
  const jsonStr = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonStr], { type: "application/json" });

  FileSaver.saveAs(blob, filename);
};
